var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.992 273.592L391.992 377.592C385.008 384.076 374.82 385.811 366.07 381.998S351.664 369.545 351.664 359.998V303.998H159.664V360C159.664 369.547 154.008 378.188 145.258 382C136.508 385.812 126.32 384.078 119.336 377.594L7.336 273.594C-2.445 264.5 -2.445 247.5 7.336 238.406L119.336 134.406C126.32 127.922 136.508 126.187 145.258 130C154.008 133.812 159.664 142.453 159.664 152V207.998H351.664V151.998C351.664 142.451 357.32 133.811 366.07 129.998S385.008 127.92 391.992 134.404L503.992 238.404C513.773 247.498 513.773 264.498 503.992 273.592Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRight);
export default __webpack_public_path__ + "static/media/left-right.b372f0af1ce7812cc029a3e7c4d36dd5.svg";
export { ForwardRef as ReactComponent };